import { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import Card from "react-bootstrap/Card";
import Alert from "react-bootstrap/Alert";
import Map from "react-map-gl";

const api = require("../Assets/api.json");

function Downloader(props) {
  const [formData, setFormData] = useState({
    template: "",
    function: "",
    name: "",
    description: "",
    format: "",
    layerName: "sample",
    inputSRS: "",
    outputSRS: "",
    minZoom: 0,
    maxZoom: 6,
    boundingBox: "",
    gZip: false,
    clipped: false,
  });

  const [authKey, setAuthKey] = useState("Bearer ");

  const [alert, setAlert] = useState({
    title: "",
    message: "",
  });

  const [isProcessing, setIsProcessing] = useState(false);
  const [isForm, setIsForm] = useState(false);
  const [isAlert, setIsAlert] = useState(false);

  const [zoom, setZoom] = useState([
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
  ]);

  const [zoomLimit, setZoomLimit] = useState([
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
  ]);

  const resetForm = () => {
    setFormData({
      template: "",
      function: "",
      name: "",
      description: "",
      format: "",
      layerName: "",
      inputSRS: "",
      outputSRS: "",
      minZoom: 0,
      maxZoom: 10,
      boundingBox: "",
      gZip: false,
      clipped: false,
    });
  };

  const downloadURI = (dataurl, filename) => {
    const link = document.createElement("a");
    link.href = dataurl;
    link.download = filename;
    link.click();
  };

  const startConversion = async () => {
    setIsProcessing(true);
    setIsAlert(false);
    setIsForm(false);

    try {
      if (formData.template && formData.template.length > 5) {
        if (formData.function && formData.function.length > 3) {
          if (
            formData.boundingBox &&
            formData.boundingBox.replaceAll(" ", "").split(",").length > 3
          ) {
            if (
              formData.name &&
              formData.name.length > 1 &&
              formData.description &&
              formData.description.length > 1 &&
              formData.format &&
              formData.format.length > 2
            ) {
              if (
                formData.inputSRS &&
                formData.inputSRS.toString().length > 3 &&
                formData.outputSRS &&
                formData.outputSRS.toString().length > 3
              ) {
                ///
                let formdata = new FormData();
                formdata.append("Function", formData.function);
                formdata.append("Name", formData.name.replaceAll(" ", "_"));
                formdata.append(
                  "LayerName",
                  formData.layerName.replaceAll(" ", "_")
                );
                formdata.append("Description", formData.description);
                formdata.append("Format", formData.format);
                formdata.append("InSRS", formData.inputSRS);
                formdata.append("OutSRS", formData.outputSRS);
                formdata.append("MinZoom", formData.minZoom);
                formdata.append("MaxZoom", formData.maxZoom);
                formdata.append("BoundingBox", formData.boundingBox);
                formdata.append("GZip", formData.gZip);
                formdata.append("Clipped", formData.clipped);
                formdata.append("Template", formData.template);

                const response = await fetch(api.endpoints.download, {
                  headers: {
                    Authorization: authKey,
                  },
                  method: "POST",
                  body: formdata,
                });

                if (response.status == 200) {
                  console.log(response);
                  const resp = await response.json();

                  if (
                    (resp.conversionStatus === "Conversion Successful",
                    resp.fileURL.length > 10 && resp.fileName.length > 4)
                  ) {
                    downloadURI(resp.fileURL, resp.fileName);
                    setIsForm(true);
                    setIsProcessing(false);
                    setIsAlert(false);
                    resetForm();
                  } else {
                    setAlert({
                      title: "Conversion Failed",
                      message: "Error occured while conversion, try later",
                    });
                    setIsForm(false);
                    setIsProcessing(false);
                    setIsAlert(true);
                  }
                } else {
                  setAlert({
                    title: "Conversion Failed",
                    message:
                      "Your session expired, login again and then convert",
                  });
                  setIsForm(false);
                  setIsProcessing(false);
                  setIsAlert(true);
                }

                ///
              } else {
                setAlert({
                  title: "Select Projection",
                  message:
                    "You did not selected the input/output file projection, kindly select valid option from list and then convert",
                });
                setIsForm(false);
                setIsProcessing(false);
                setIsAlert(true);
              }
            } else {
              setAlert({
                title: "Enter  Metadata Details (Name/Description/Format)",
                message: "You did not entered Metadata details",
              });
              setIsForm(false);
              setIsProcessing(false);
              setIsAlert(true);
            }
          } else {
            setAlert({
              title: "Invalid Bounding Box",
              message:
                "You did not entered BBOX in valid format, supported formate like -180,-85.05112877980659,180,85.05112877980659",
            });
            setIsForm(false);
            setIsProcessing(false);
            setIsAlert(true);
          }
        } else {
          setAlert({
            title: "Select Function",
            message:
              "You did not selected the output function, kindly select either MBTiles or GPKG and then convert",
          });
          setIsForm(false);
          setIsProcessing(false);
          setIsAlert(true);
        }
      } else {
        setAlert({
          title: "Enter Template URL",
          message:
            "You did not entered layer url, kindly enter and then convert",
        });
        setIsForm(false);
        setIsProcessing(false);
        setIsAlert(true);
      }
    } catch (error) {
      console.log(error);
      setIsProcessing(false);
      setIsAlert(false);
      setIsForm(true);
    }
  };

  useEffect(() => {
    let token = localStorage.getItem("esri-tile-converter-token");
    if (token) {
      setAuthKey(`Bearer ${token}`);
    } else {
      setAlert({
        title: "Not Login",
        message: "Your session is expired, Kindly login again",
      });
      setIsForm(false);
      setIsProcessing(false);
      setIsAlert(true);
    }
    setIsForm(true);
    setIsProcessing(false);
    setIsAlert(false);
  }, []);

  return (
    <div>
      {/* <h2>Convert Mbtiles (Raster/Vector) into (TPKX/VTPK)</h2> */}
      {isForm && (
        <Card style={{ marginTop: 80, marginBottom: 20 }}>
          <Card.Header>
            Download ZXY Hosted Tile Layer into MBTiles / GeoPakckage
          </Card.Header>
          <Card.Body>
            <Form>
              <Container>
                <Card.Title>Input Details</Card.Title>

                <Row>
                  <Col>
                    <Form.Label>Layer URL</Form.Label>
                  </Col>
                  <Col>
                    <Form.Control
                      type="text"
                      value={formData.template}
                      placeholder="Enter {Z} {X} {Y} Layer URL"
                      onChange={(e) =>
                        setFormData((existing) => ({
                          ...existing,
                          template: e.target.value,
                        }))
                      }
                    />
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Label>Function</Form.Label>
                  </Col>
                  <Col>
                    <Form.Select
                      aria-label="Select Function"
                      value={formData.function}
                      onChange={(e) =>
                        setFormData((existing) => ({
                          ...existing,
                          function: e.target.value,
                        }))
                      }
                    >
                      <option>Select</option>
                      <option value="generate_gpkg">
                        Download as GeoPakckage
                      </option>
                      <option value="generate_mbtiles">
                        Download as MBTiles
                      </option>
                    </Form.Select>
                  </Col>
                </Row>

                <Card.Title>Metadata Details</Card.Title>

                <Row>
                  <Col>
                    <Form.Label>Metadata Name</Form.Label>
                  </Col>
                  <Col>
                    <Form.Control
                      type="text"
                      value={formData.name}
                      placeholder="Metadata Name"
                      onChange={(e) =>
                        setFormData((existing) => ({
                          ...existing,
                          name: e.target.value,
                        }))
                      }
                    />
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Label>Metadata Description</Form.Label>
                  </Col>
                  <Col>
                    <Form.Control
                      type="text"
                      value={formData.description}
                      placeholder="Metadata Description"
                      onChange={(e) =>
                        setFormData((existing) => ({
                          ...existing,
                          description: e.target.value,
                        }))
                      }
                    />
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Label>Output File Format</Form.Label>
                  </Col>
                  <Col>
                    <Form.Select
                      aria-label="Select Output Format"
                      value={formData.format}
                      onChange={(e) =>
                        setFormData((existing) => ({
                          ...existing,
                          format: e.target.value,
                        }))
                      }
                    >
                      <option>Select</option>
                      <option value="pbf">PBF</option>
                      <option value="png">PNG</option>
                      <option value="jpg">JPG</option>
                      <option value="jpeg">JPEG</option>
                      <option value="webp">WEBP</option>
                    </Form.Select>
                  </Col>
                </Row>

                {formData.function === "generate_gpkg" && (
                  <Row>
                    <Col>
                      <Form.Label>Layer Name</Form.Label>
                    </Col>
                    <Col>
                      <Form.Control
                        type="text"
                        value={formData.layerName}
                        placeholder="Layer Name"
                        onChange={(e) =>
                          setFormData((existing) => ({
                            ...existing,
                            layerName: e.target.value,
                          }))
                        }
                      />
                    </Col>
                  </Row>
                )}

                <Card.Title>Projection Details</Card.Title>

                <Row>
                  <Col>
                    <Form.Label>Bounding Box</Form.Label>
                  </Col>
                  <Col>
                    <Form.Control
                      type="text"
                      value={formData.boundingBox}
                      placeholder="Format minx,miny,maxx,maxy"
                      onChange={(e) =>
                        setFormData((existing) => ({
                          ...existing,
                          boundingBox: e.target.value,
                        }))
                      }
                    />
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Label>Input Bounds Projection</Form.Label>
                  </Col>
                  <Col>
                    <Form.Select
                      aria-label="Select Input SRS"
                      value={formData.inputSRS}
                      onChange={(e) =>
                        setFormData((existing) => ({
                          ...existing,
                          inputSRS: e.target.value,
                        }))
                      }
                    >
                      <option>Select</option>
                      <option value="3395">EPSG - 3395</option>
                      <option value="3857">EPSG - 3857</option>
                      <option value="4326">EPSG - 4326</option>
                    </Form.Select>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Label>Output File Projection</Form.Label>
                  </Col>
                  <Col>
                    <Form.Select
                      aria-label="Select Output SRS"
                      value={formData.outputSRS}
                      onChange={(e) =>
                        setFormData((existing) => ({
                          ...existing,
                          outputSRS: e.target.value,
                        }))
                      }
                    >
                      <option>Select</option>
                      <option value="3395">EPSG - 3395</option>
                      <option value="3857">EPSG - 3857</option>
                      <option value="4326">EPSG - 4326</option>
                    </Form.Select>
                  </Col>
                </Row>

                <Card.Title>Other Details</Card.Title>

                <Row>
                  <Col>
                    <Form.Label>Min Zoom</Form.Label>
                  </Col>
                  <Col>
                    <Form.Select
                      aria-label="Select MinZoom"
                      value={formData.minZoom}
                      onChange={(e) => {
                        setFormData((existing) => ({
                          ...existing,
                          minZoom: e.target.value,
                          maxZoom: e.target.value + 1,
                        }));

                        let temp = [];

                        for (let i = e.target.value; i <= 19; i++) {
                          temp.push(i);
                        }

                        setZoomLimit(temp);
                      }}
                    >
                      <option>Select</option>
                      {zoom.map((value, i) => (
                        <option key={i} value={value}>
                          {value}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Label>Max Zoom</Form.Label>
                  </Col>
                  <Col>
                    <Form.Select
                      aria-label="Select MinZoom"
                      value={formData.maxZoom}
                      onChange={(e) =>
                        setFormData((existing) => ({
                          ...existing,
                          maxZoom: e.target.value,
                        }))
                      }
                    >
                      <option>Select</option>
                      {zoomLimit.map((value, i) => (
                        <option key={i} value={value}>
                          {value}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                </Row>

                {formData.format === "pbf" && (
                  <Row>
                    <Col>
                      <Form.Label>GZIP Data</Form.Label>
                    </Col>
                    <Col>
                      <Form.Select
                        aria-label="Select"
                        value={formData.gZip}
                        onChange={(e) =>
                          setFormData((existing) => ({
                            ...existing,
                            gZip: e.target.value,
                          }))
                        }
                      >
                        <option>Select</option>
                        <option value={true}>Yes</option>
                        <option value={false}>No</option>
                      </Form.Select>
                    </Col>
                  </Row>
                )}

                {formData.function === "generate_mbtiles" && (
                  <Row>
                    <Col>
                      <Form.Label>Clip to BBOX</Form.Label>
                    </Col>
                    <Col>
                      <Form.Select
                        aria-label="Select"
                        value={formData.clipped}
                        onChange={(e) =>
                          setFormData((existing) => ({
                            ...existing,
                            clipped: e.target.value,
                          }))
                        }
                      >
                        <option>Select</option>
                        <option value={true}>Yes</option>
                        <option value={false}>No</option>
                      </Form.Select>
                    </Col>
                  </Row>
                )}

                {/* <div>
                  <Map
                    mapboxAccessToken="pk.eyJ1IjoibXViYXNoaXJnaXMiLCJhIjoiY2x0eTh6Y29zMDdrZzJrbWttNWx1dHBnMCJ9.oelRhyJyHl5_cNbguMHBwg"
                    initialViewState={{
                      longitude: -122.4,
                      latitude: 37.8,
                      zoom: 14,
                    }}
                    style={{ width: "100%", height: "100%" }}
                    mapStyle="mapbox://styles/mapbox/streets-v9"
                  />
                </div> */}

                <Row>
                  <Col></Col>
                  <Col>
                    <Button variant="success" onClick={() => startConversion()}>
                      Convert
                    </Button>
                  </Col>
                  <Col></Col>
                </Row>
              </Container>
            </Form>
          </Card.Body>
        </Card>
      )}

      {isProcessing && (
        <Card style={{ margin: 20 }}>
          <Card.Header>Processing</Card.Header>
          <Card.Body>
            <Spinner animation="grow" variant="success" />
          </Card.Body>
        </Card>
      )}

      {isAlert && (
        <Alert show={isAlert} variant="info">
          <Alert.Heading>{alert.title}</Alert.Heading>
          <p>{alert.message}</p>
          <hr />
          <div className="d-flex justify-content-end">
            <Button
              onClick={() => {
                setIsAlert(false);
                setIsForm(true);
                setIsProcessing(false);
                setAlert({
                  title: "",
                  message: "",
                });
              }}
              variant="outline-info"
            >
              Ok
            </Button>
          </div>
        </Alert>
      )}
    </div>
  );
}
export default Downloader;
